"use strict";
var $a5fd07fa01589658$exports = {};
"use strict";
class $a5fd07fa01589658$var$Game {
    constructor(initialState = null){
        this.score = 0;
        this.status = "idle";
        this.initialState = initialState ? JSON.parse(JSON.stringify(initialState)) : null;
        this.state = initialState ? JSON.parse(JSON.stringify(initialState)) : this.createEmptyBoard();
    }
    createEmptyBoard() {
        return Array.from({
            length: $a5fd07fa01589658$var$Game.SIZE
        }, ()=>Array($a5fd07fa01589658$var$Game.SIZE).fill(0));
    }
    addRandomTile() {
        const emptyTiles = [];
        for(let row = 0; row < $a5fd07fa01589658$var$Game.SIZE; row++){
            for(let col = 0; col < $a5fd07fa01589658$var$Game.SIZE; col++)if (this.state[row][col] === 0) emptyTiles.push({
                row: row,
                col: col
            });
        }
        if (emptyTiles.length > 0) {
            const { row: row, col: col } = emptyTiles[Math.floor(Math.random() * emptyTiles.length)];
            this.state[row][col] = Math.random() < $a5fd07fa01589658$var$Game.TILE_PROBABILITY ? 2 : 4;
        }
    }
    checkGameState() {
        if (this.state.some((row)=>row.includes($a5fd07fa01589658$var$Game.WIN_TILE_VALUE))) {
            this.status = "win";
            return;
        }
        if (!this.canMove()) this.status = "lose";
    }
    canMove() {
        for(let row = 0; row < $a5fd07fa01589658$var$Game.SIZE; row++)for(let col = 0; col < $a5fd07fa01589658$var$Game.SIZE; col++){
            if (this.state[row][col] === 0) return true;
            if (row < $a5fd07fa01589658$var$Game.SIZE - 1 && this.state[row][col] === this.state[row + 1][col] || col < $a5fd07fa01589658$var$Game.SIZE - 1 && this.state[row][col] === this.state[row][col + 1]) return true;
        }
        return false;
    }
    move(direction) {
        if (this.status !== "playing") return;
        const previousState = JSON.stringify(this.state);
        if (direction === "left") this.state = this.shiftLeft(this.state);
        if (direction === "right") this.state = this.shiftRight(this.state);
        if (direction === "up") this.state = this.shiftUp(this.state);
        if (direction === "down") this.state = this.shiftDown(this.state);
        if (JSON.stringify(this.state) !== previousState) this.addRandomTile();
        this.checkGameState();
    }
    shiftLeft(state) {
        return state.map((row)=>this.compressRow(row));
    }
    shiftRight(state) {
        return state.map((row)=>this.compressRow([
                ...row
            ].reverse()).reverse());
    }
    shiftUp(state) {
        const transposed = this.transpose(state);
        const shifted = this.shiftLeft(transposed);
        return this.transpose(shifted);
    }
    shiftDown(state) {
        const transposed = this.transpose(state);
        const shifted = this.shiftRight(transposed);
        return this.transpose(shifted);
    }
    compressRow(row) {
        const filtered = row.filter((value)=>value !== 0);
        for(let i = 0; i < filtered.length - 1; i++)if (filtered[i] === filtered[i + 1]) {
            filtered[i] *= 2;
            this.score += filtered[i];
            filtered[i + 1] = 0;
        }
        const filtered2 = filtered.filter((value)=>value !== 0);
        return [
            ...filtered2,
            ...Array($a5fd07fa01589658$var$Game.SIZE - filtered2.length).fill(0)
        ];
    }
    transpose(matrix) {
        return matrix[0].map((_, colIndex)=>matrix.map((row)=>row[colIndex]));
    }
    moveUp() {
        this.move("up");
    }
    moveDown() {
        this.move("down");
    }
    moveLeft() {
        this.move("left");
    }
    moveRight() {
        this.move("right");
    }
    getState() {
        return this.state;
    }
    getScore() {
        return this.score;
    }
    getStatus() {
        return this.status;
    }
    start() {
        if (this.status === "idle") {
            this.resetGame();
            this.status = "playing";
            this.addRandomTile();
            this.addRandomTile();
        }
    }
    restart() {
        this.resetGame();
        this.status = "idle";
    }
    resetGame() {
        this.state = this.initialState ? JSON.parse(JSON.stringify(this.initialState)) : this.createEmptyBoard();
        this.score = 0;
    }
}
$a5fd07fa01589658$var$Game.TILE_PROBABILITY = 0.9;
$a5fd07fa01589658$var$Game.SIZE = 4;
$a5fd07fa01589658$var$Game.WIN_TILE_VALUE = 2048;
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


const $09e991522ca7e64e$var$game = new $a5fd07fa01589658$exports();
const $09e991522ca7e64e$var$button = document.querySelector(".button");
const $09e991522ca7e64e$var$gameField = document.querySelector(".game-field");
const $09e991522ca7e64e$var$gameScore = document.querySelector(".game-score");
const $09e991522ca7e64e$var$messageLose = document.querySelector(".message-lose");
const $09e991522ca7e64e$var$messageWin = document.querySelector(".message-win");
const $09e991522ca7e64e$var$messageStart = document.querySelector(".message-start");
$09e991522ca7e64e$var$button.addEventListener("click", ()=>{
    const isIdle = $09e991522ca7e64e$var$game.getStatus() === "idle";
    $09e991522ca7e64e$var$game[isIdle ? "start" : "restart"]();
    $09e991522ca7e64e$var$button.textContent = isIdle ? "Restart" : "Start";
    $09e991522ca7e64e$var$button.classList.toggle("start", !isIdle);
    $09e991522ca7e64e$var$button.classList.toggle("restart", isIdle);
    $09e991522ca7e64e$var$updateUI();
});
document.addEventListener("keydown", (e)=>{
    e.preventDefault();
    if ($09e991522ca7e64e$var$game.getStatus() !== "playing") return;
    switch(e.key){
        case "ArrowLeft":
            $09e991522ca7e64e$var$game.moveLeft();
            break;
        case "ArrowRight":
            $09e991522ca7e64e$var$game.moveRight();
            break;
        case "ArrowUp":
            $09e991522ca7e64e$var$game.moveUp();
            break;
        case "ArrowDown":
            $09e991522ca7e64e$var$game.moveDown();
            break;
        default:
            return;
    }
    $09e991522ca7e64e$var$updateUI();
});
function $09e991522ca7e64e$var$updateUI() {
    $09e991522ca7e64e$var$renderBoard();
    $09e991522ca7e64e$var$updateScore();
    $09e991522ca7e64e$var$updateMessages();
}
function $09e991522ca7e64e$var$renderBoard() {
    const board = $09e991522ca7e64e$var$game.getState();
    $09e991522ca7e64e$var$gameField.querySelectorAll(".field-cell").forEach((cell, index)=>{
        const row = Math.floor(index / 4);
        const col = index % 4;
        const value = board[row][col];
        cell.textContent = value === 0 ? "" : value;
        cell.className = `field-cell${value ? ` field-cell--${value}` : ""}`;
    });
}
function $09e991522ca7e64e$var$updateScore() {
    $09e991522ca7e64e$var$gameScore.textContent = $09e991522ca7e64e$var$game.getScore();
}
function $09e991522ca7e64e$var$updateMessages() {
    const gameStatus = $09e991522ca7e64e$var$game.getStatus();
    const messages = {
        lose: $09e991522ca7e64e$var$messageLose,
        win: $09e991522ca7e64e$var$messageWin,
        start: $09e991522ca7e64e$var$messageStart
    };
    Object.keys(messages).forEach((key)=>{
        messages[key].classList.toggle("hidden", key !== gameStatus);
    });
}


//# sourceMappingURL=index.55eb4e4c.js.map
